<template>
  <transition name="el-fade-in">
    <div v-if="visible" class="cm-overlay" @click.self="close">
      <div class="cm-dialog">
        <button class="cm-close" @click="close">×</button>
        <button type="button" class="cm-banner-button" :disabled="navigating" @click="onBannerClick">
          <img :src="image" alt="インフルエンサー紹介 AIスライド出力" class="cm-image hover-glow" />
        </button>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'CampaignModal',
  props: {
    image: { type: String, required: true },
    visible: { type: Boolean, default: false }
  },
  data() {
    return {
      navigating: false
    };
  },
  methods: {
    close() { this.$emit('close'); },
    onBannerClick() {
      if (this.navigating) return;
      this.navigating = true;
      this.$emit('click-banner');
    }
  }
}
</script>

<style scoped>
.cm-overlay{
  position: fixed; inset: 0;
  background: rgba(0,0,0,0.6);
  z-index: 3000;
  display: flex; align-items: center; justify-content: center;
}
.cm-dialog{
  position: relative;
  max-width: 80vw; max-height: 80vh;
  background: #0000;
  display:flex; align-items:center; justify-content:center;
}
.cm-banner-button{
  padding: 0;
  border: none;
  background: transparent;
  cursor: pointer;
  display: block;
}
.cm-banner-button:disabled{
  cursor: wait;
}
.cm-image{
  max-width: 80vw; max-height: 80vh; display:block;
  z-index: 1;
}
.cm-close{
  position: absolute; top: -12px; right: -12px;
  width: 32px; height: 32px; border-radius: 50%;
  border: none; cursor: pointer; font-size: 20px;
  background: #fff; box-shadow: 0 2px 8px rgba(0,0,0,.25);
  z-index: 100;
}
.hover-glow {
  position: relative;
  transition: box-shadow 0.8s ease, filter 0.8s ease;
  z-index: 2;
}
.hover-glow:hover {
  filter: brightness(1.05);
  box-shadow: 0 0 10px rgba(255, 255, 255, 0.15);
}
.hover-glow::after {
  content: "";
  position: absolute;
  top: 0;
  left: -80%;
  width: 40%;
  height: 100%;
  background: linear-gradient(
      120deg,
      rgba(255, 255, 255, 0.08) 0%,
      rgba(255, 255, 255, 0.15) 50%,
      rgba(255, 255, 255, 0.08) 100%
  );
  transform: skewX(-25deg);
  transition: left 1.5s ease;
  pointer-events: none;
  z-index: 3;
}
.hover-glow:hover::after {
  left: 130%;
}

</style>
